import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import FullWidthPage from "@SupplyLand/MobiusOverrides/Page/FullWidthPage";
import * as React from "react";

export interface HomePageStyles {
    page?: MobiusPageProps;
    fullWidthPage?: MobiusPageProps;
}

export const homePageStyles: HomePageStyles = {
    fullWidthPage: {
        fullWidth: [true, true, true, true, true],
    },
};

const styles = homePageStyles;

const HomePage = ({ id, generalFields }: PageProps) => (
    <>
        {generalFields.hideFooter &&
        generalFields.hideFooter === true &&
        generalFields.hideHeader &&
        generalFields.hideHeader === true ? (
            <FullWidthPage data-test-selector="homePage" {...styles.fullWidthPage}>
                <Zone contentId={id} zoneName="ComingSoonZone" />
                <Modals />
            </FullWidthPage>
        ) : (
            <Page data-test-selector="homePage" {...styles.page}>
                <Zone contentId={id} zoneName="Content" requireRows />
                <Modals />
            </Page>
        )}
    </>
);

const pageModule: PageModule = {
    component: HomePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            StructuredPageData,
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "HomePage" instead of this constant.
 */
export const HomePageContext = "HomePage";
